// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"3aa9513f","147":"520d3830","168":"3c8214de","212":"8bb99636","318":"7651f0f7","411":"ec0cd290","506":"eb17bb16","536":"506316b4","588":"f067348c","618":"0a698bbe","689":"ce6a1542","799":"fb5ae521","832":"5f49eb75","869":"dc170540"}[chunkId] + ".chunk.js";
};